import BaseType from "../BaseType";

//id was previously defaulted to blank string
export default class WorkshopType extends BaseType {
  Name: string = "";
  SortOrder: number = 0;
}
